import { TestletType } from '../constants/testlet-type.enum';

export const OverviewCard = {
  [TestletType.Symbols]: {
    label: 'Symbols',
    icon: 'assets/icons/symbols.svg',
  },
  [TestletType.SimilarWords]: {
    label: 'Similar words',
    icon: 'assets/icons/similar-words.svg',
  },
  [TestletType.NumberRecall]: {
    label: 'Number recall',
    icon: 'assets/icons/number-recall.svg',
  },
  [TestletType.PictureCompletion]: {
    label: 'Picture completion',
    icon: 'assets/icons/picture-completion.svg',
  },
  [TestletType.FakeWords]: {
    label: 'Fake words',
    icon: 'assets/icons/fake-words.svg',
  },
  [TestletType.MissingNumbers]: {
    label: 'Missing numbers',
    icon: 'assets/icons/missing-numbers.svg',
  },
  [TestletType.Objects]: {
    label: 'Objects',
    icon: 'assets/icons/objects.svg',
  },
  [TestletType.ShapesAndColors]: {
    label: 'Shapes and colours',
    icon: 'assets/icons/shapes-and-colours.svg',
  },
};
